import { DateMonth, formatMonthYearPeriod, MonthYear } from '@common/neo.tax';

/**
 * Generates the label for the year. If the fiscal year end month is December, the label will be
 * the year. If the fiscal year end month is not December, the label will be the starting month
 * and year to the ending month and year.
 */
export const makeYearLabel = (yearEndMonthYear: MonthYear): string => {
  if (yearEndMonthYear.month === DateMonth.December) {
    return `${yearEndMonthYear.year}`;
  }

  const startMonthYear = {
    month: (yearEndMonthYear.month + 1) % 12,
    year: yearEndMonthYear.year - 1,
  };
  const monthYearFormatted = formatMonthYearPeriod({
    startMonthYear: startMonthYear,
    endMonthYear: yearEndMonthYear,
  });
  return `${monthYearFormatted.start} - ${monthYearFormatted.end}`;
};
